import { render } from "./UiResult.vue?vue&type=template&id=0748611d&ts=true"
import script from "./UiResult.vue?vue&type=script&lang=ts"
export * from "./UiResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__